import { Link } from "react-router-dom";
import { Phone, MapPin, Clock, Sparkles } from "lucide-react";
import { useApp } from "../context/AppContext";
import SocialIcon from "./SocialIcon";

export default function Footer() {
  const { t, settings, L } = useApp();
  const c = settings?.contact || {};
  const socials = settings?.socials || [];
  const brand = settings ? L(settings, "brand_name") : t.brand;

  const links = [
    { to: "/services", label: t.nav.services },
    { to: "/offers", label: t.nav.offers },
    { to: "/book", label: t.nav.book },
    { to: "/my-bookings", label: t.nav.myBookings },
    { to: "/contact", label: t.nav.contact },
  ];

  return (
    <footer className="mt-24 border-t border-border bg-card" data-testid="site-footer">
      <div className="px-4 sm:px-8 lg:px-16 max-w-7xl mx-auto py-14 grid gap-10 md:grid-cols-4">
        <div className="md:col-span-2">
          <div className="flex items-center gap-2 mb-4">
            <span className="grid place-items-center h-9 w-9 rounded-full cb-gradient text-primary-foreground">
              <Sparkles className="h-5 w-5" />
            </span>
            <span className="font-display text-2xl font-bold">{brand}</span>
          </div>
          <p className="text-muted-foreground max-w-md leading-relaxed">{t.footer.about}</p>
          <div className="flex items-center gap-3 mt-6">
            {socials.map((s, i) => (
              <a
                key={i}
                href={s.url}
                target="_blank"
                rel="noopener noreferrer"
                data-testid={`social-link-${s.platform}`}
                className="grid place-items-center h-10 w-10 rounded-full bg-muted hover:bg-primary hover:text-primary-foreground transition-colors"
                aria-label={s.platform}
              >
                <SocialIcon platform={s.platform} className="h-5 w-5" />
              </a>
            ))}
          </div>
        </div>

        <div>
          <h4 className="font-semibold mb-4">{t.footer.quickLinks}</h4>
          <ul className="space-y-2">
            {links.map((l) => (
              <li key={l.to}>
                <Link to={l.to} className="text-muted-foreground hover:text-primary transition-colors">
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="font-semibold mb-4">{t.footer.contactUs}</h4>
          <ul className="space-y-3 text-muted-foreground">
            {c.phone && (
              <li className="flex items-center gap-2">
                <Phone className="h-4 w-4 text-primary" />
                <a href={`tel:${c.phone}`} className="hover:text-primary" dir="ltr">{c.phone}</a>
              </li>
            )}
            <li className="flex items-center gap-2">
              <Clock className="h-4 w-4 text-primary" />
              {L(c, "hours")}
            </li>
          </ul>
        </div>
      </div>
      <div className="border-t border-border py-5 text-center text-sm text-muted-foreground">
        © {new Date().getFullYear()} {brand} — {t.footer.rights}
      </div>
    </footer>
  );
}
